import React, { Component } from 'react';
import './MyNFTs.css';
import './CreatorProfile.css';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from "./utils/loggingUtils";
import * as scriptUtils from './utils/scriptUtils';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import CreatedNFT from './CreatedNFT';
import ImportFromPassword from './ImportFromPassword';
import logo2 from './logo2.png';

class CreatorProfile extends Component {
  constructor(props) {
    super(props);
    this.selectModal = this.selectModal.bind(this);
    this.onClickNFT = this.onClickNFT.bind(this);
    this.handleCatalogNameChange = this.handleCatalogNameChange.bind(this);
    this.handleTwitterChange = this.handleTwitterChange.bind(this);
    this.handleOtherAddressChange = this.handleOtherAddressChange.bind(this);
    this.handleGlassCollectionStringChange = this.handleGlassCollectionStringChange.bind(this);
    this.submitForSync = this.submitForSync.bind(this);

    this.state = {
      address: '',
      twitter: '',
      otherAddress: '',
      modalShown: '',
      catalogName: '',
      createdNFTs: [],
      offPlatformNFTs: [],
      glassCollectionString: '',
    }
  }

  handleCatalogNameChange(event) {
    this.setState({
      catalogName: event.target.value,
    });
  }

  handleTwitterChange(event) {
    this.setState({
      twitter: event.target.value,
    });
  }

  handleOtherAddressChange(event) {
    this.setState({
      otherAddress: event.target.value,
    });
  }

  handleGlassCollectionStringChange(event) {
    this.setState({
      glassCollectionString: event.target.value,
    });
  }

  filterDuplicates(nfts) {
    let seenAnimationAndImageURLs = {};
    let ans = [];
    for(let i = 0; i < nfts.length; i++) {
      let nft = nfts[i];
      let animation_original_url = nft["animation_original_url"] != null ? nft["animation_original_url"] : "None";
      let image_url = nft["image_url"] != null ? nft["image_url"] : "None";
      let combinedKey = animation_original_url + "_" + image_url;
      if(combinedKey in seenAnimationAndImageURLs) {
        continue;
      } else {
        ans.push(nft);
        seenAnimationAndImageURLs[combinedKey] = true;
      }
    }
    return ans;
  }

  async submitForSync(event) {
    let catalogName = this.state.catalogName != null && this.state.catalogName !== "" ? this.state.catalogName : "None";
    let otherAddress = this.state.otherAddress != null && this.state.otherAddress !== "" && this.state.otherAddress !== "None" ? this.state.otherAddress.toLowerCase() : "None";
    let glassCollections = [];
    if(this.state.glassCollectionString !== "") {
      glassCollections = this.state.glassCollectionString.split(",");
    }
    let twitter = this.state.twitter != null && this.state.twitter !== "" ? this.state.twitter : "None";
    let handle = "";
    if(twitter !== "None") {
      handle = twitter;
      if(twitter.includes("/")) {
        let twitterSplit = twitter.split("/")
        let handle = twitterSplit[twitterSplit.length - 1];
      } else if(twitter.includes("@")) {
        let twitterSplit = twitter.split("@")
        let handle = twitterSplit[twitterSplit.length - 1];
      }
      twitter = "https://twitter.com/" + handle;
    }
    glassCollections = glassCollections.map(slug => slug.trim());
    await encryptUtils.getNFTsFromOpensea(this.state.address, catalogName, otherAddress, glassCollections, twitter);
    let allNFTs = await encryptUtils.getNFTsFromAPI(this.state.address);
    let artistName = "";
    let artistTwitter = "";
    let offPlatformNFTs = [];
    if(allNFTs != null && allNFTs.data != null && allNFTs.data.length > 0) {
      offPlatformNFTs = allNFTs.data[0].info.openseaItems;
      offPlatformNFTs.push(...allNFTs.data[0].info.catalogItems);
      artistName = allNFTs.data[0].catalogName;
      artistTwitter = allNFTs.data[0].twitter;
    }
    offPlatformNFTs = this.filterDuplicates(offPlatformNFTs);
    let createdNFTs = await encryptUtils.getCreatedNFTs(this.state.address);
    if(otherAddress !== "None") {
      let otherAddressCreatedNFTs = await encryptUtils.getCreatedNFTs(otherAddress);
      createdNFTs.push(...otherAddressCreatedNFTs);
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "creator_profile",
      "creator_profile_submit_sync",
      "info",
      "https://the402.xyz",
      {}
    );
    this.setState({
      catalogName: artistName,
      twitter: handle,
      createdNFTs,
      offPlatformNFTs,
    });
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  async componentDidMount() {
    let urlSplit = window.location.href.split("/");
    let address = urlSplit[urlSplit.length - 1].toLowerCase();
    let otherAddress = "None";
    let allNFTs = await encryptUtils.getNFTsFromAPI(address);
    if(allNFTs == null || allNFTs.data == null || allNFTs.data.length === 0) {
      await encryptUtils.getNFTsFromOpensea(address, "None", "None", [], "None");
      allNFTs = await encryptUtils.getNFTsFromAPI(address);
    } else {
      otherAddress = allNFTs.data[0].otherAddress;
    }
    let artistName = "";
    let artistTwitter = "";
    let offPlatformNFTs = [];
    if(allNFTs != null && allNFTs.data != null && allNFTs.data.length > 0) {
      offPlatformNFTs = allNFTs.data[0].info.openseaItems;
      offPlatformNFTs.push(...allNFTs.data[0].info.catalogItems);
      artistName = allNFTs.data[0].catalogName;
      artistTwitter = allNFTs.data[0].twitter;
    }
    offPlatformNFTs = this.filterDuplicates(offPlatformNFTs);
    let createdNFTs = await encryptUtils.getCreatedNFTs(address);
    if(otherAddress != null && otherAddress !== "" && otherAddress !== "None") {
      let otherAddressCreatedNFTs = await encryptUtils.getCreatedNFTs(otherAddress);
      createdNFTs.push(...otherAddressCreatedNFTs);
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "creator_profile",
      "creator_profile_load",
      "info",
      "https://the402.xyz",
      {}
    );
    this.setState({
      catalogName: artistName,
      twitter: artistTwitter,
      address,
      createdNFTs,
      offPlatformNFTs,
    });
  }

  onClickNFT(item) {
    window.location.href = "http://localhost:3000/media/" + item.authUUID;
  }

  render() {
    let twitterHandle = this.state.twitter;
    if(this.state.twitter.includes("/")) {
      let twitterSplit = this.state.twitter.split("/");
      twitterHandle = twitterSplit[twitterSplit.length - 1];
    } else if(this.state.twitter.includes("@")) {
      let twitterSplit = this.state.twitter.split("@");
      twitterHandle = twitterSplit[twitterSplit.length - 1];
    }
    return(
      <div>
        <div className="min-h-screen">
          {
            this.props.account != null && this.props.account.address.toLowerCase() === this.state.address.toLowerCase()
              ?
            <div>
              <label className="text-black dark:text-white font-semibold mt-8">
                What is your artist name?
                <input
                  placeholder="Artist Name"
                  className="placeholder-gray-500 font-medium w-full p-4 mt-2 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
                  value={this.state.catalogName}
                  onChange={this.handleCatalogNameChange}
                />
              </label>
              <label className="text-black dark:text-white font-semibold mt-8">
                What is your Twitter?
                <input
                  placeholder="Twitter"
                  className="placeholder-gray-500 font-medium w-full p-4 mt-2 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
                  value={this.state.twitter}
                  onChange={this.handleTwitterChange}
                />
              </label>
              <label className="text-black dark:text-white font-semibold mt-8">
                Any other address you've used to create NFTs that you want to include here?
                <input
                  placeholder="Alternate address"
                  className="placeholder-gray-500 font-medium w-full p-4 mt-2 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
                  value={this.state.otherAddress}
                  onChange={this.handleOtherAddressChange}
                />
              </label>
              <label className="text-black dark:text-white font-semibold mt-8">
                Comma separated list of other Opensea collections (e.g. Glass)
                <input
                  placeholder="Collection IDs"
                  className="placeholder-gray-500 font-medium w-full p-4 mt-2 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
                  value={this.state.glassCollectionString}
                  onChange={this.handleGlassCollectionStringChange}
                />
              </label>
              <button onClick={async () => await this.submitForSync()}>
                Sync Latest NFTs
              </button>
            </div>
              :
            null
          }
          <div className="w-screen flex justify-center">
            <img className="h-12 w-auto mt-6 cursor-pointer" src={logo2} onClick={()=> window.open("https://app.the402.xyz/", "_self")} />
          </div>
          <div className="w-full justify-center items-center flex flex-col justify-center">
            {
              this.state.catalogName != null && this.state.catalogName !== "" && this.state.catalogName !== "None"
                ?
              <div className="w-11/12 sm:justify-start flex justify-center mt-4 text-2xl text-gray-800 dark:text-zinc-300">
                {this.state.catalogName}
              </div>
                :
              null
            }
            {
              this.state.twitter != null && this.state.twitter !== "" && this.state.twitter !== "None"
                ?
              <div className="w-11/12 sm:justify-start flex justify-center text-sm text-gray-600 dark:text-zinc-500">
                {"@" + twitterHandle}
              </div>
                :
              null
            }
          <div className="mt-8 sm:mt-8 w-11/12 grid grid-cols-1 xl:grid-cols-4 xl:gap-2 lg:grid-cols-2 lg:gap-4">
            {
              this.state.createdNFTs.map(createdNFT => {
                let image = scriptUtils.getProfileImage(createdNFT.creatorAddress);
                return (
                  <CreatedNFT
                    key={createdNFT.authUUID}
                    image={createdNFT.imagePinata}
                    name={createdNFT.name.split("_").join(" ")}
                    address={createdNFT.displayedCreatorAddress}
                    addressImage={image}
                    handleItemClick={() => {
                      window.location.href = window.location.origin + "/media/" + createdNFT.authUUID + "?protocol=" + createdNFT.protocol;
                    }}
                    handleCTAClick={() => {
                      window.location.href = window.location.origin + "/media/" + createdNFT.authUUID + "?protocol=" + createdNFT.protocol;
                    }}
                    ctaText="Buy"
                    editions={createdNFT.amount}
                    price={createdNFT.price}
                  />
                );
              })
            }
            {
              this.state.offPlatformNFTs.map(createdNFT => {
                let image = scriptUtils.getProfileImage(this.state.address);
                return (
                  <CreatedNFT
                    key={createdNFT.name + createdNFT.image_url}
                    image={createdNFT.image_url}
                    name={createdNFT.name}
                    address={this.state.address.substring(0, 5) + "..." + this.state.address.substring(this.state.address.length - 5)}
                    addressImage={image}
                    handleItemClick={() => {
                      window.open(createdNFT.external_link, "_blank");
                    }}
                    handleCTAClick={() => {
                      window.open(createdNFT.external_link, "_blank");
                    }}
                    ctaText="Buy"
                  />
                );
              })
            }
          </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreatorProfile;
